<template>
    <div class="">
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Reports<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / Leave & Attendance Reports</span>
        </h4>
        <div class="row no-margin mt-4">
            <div class="ibox col-md-12">
                <div class="ibox-content pt-3">
                    <div class="row">
                        <div class="col-md-4 pl-0">
                            <!-- <div class="stats-info flex-fill">
                                <h6 class="text-left">Leave Report</h6>
                                <hr>
                                <p class="text-left">
                                    <span class="font-weight-normal">
                                        This report shows detailed leave count of employees for each type of leave.
                                    </span>
                                </p>
                                <div class="mt-2">
                                    <div class="d-flex justify-content-start">
                                        <b-button @click="ShowLeaveReportModal"> View Report</b-button>
                                    </div>
                                </div>
                            </div> -->
                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
                                <h5>Leave Report</h5>
                                <p>This report shows detailed leave count of employees for each type of leave.</p>
                                <b-button @click="ShowLeaveReportModal"> View Report</b-button>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <!-- <div class="stats-info flex-fill">
                                <h6 class="text-left">Leave Request Report</h6>
                                <hr>
                                <p class="text-left">
                                    <span class="font-weight-normal">
                                        This report shows all the leave requests made by employees within a particular period along with description and status.
                                    </span>
                                </p>
                                <div class="mt-1">
                                    <div class="d-flex justify-content-start">
                                        <b-button @click="ShowLeaveRequestReportModal" > View Report</b-button>
                                    </div>
                                </div>
                            </div> -->
                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
                                <h5>Leave Request Report</h5>
                                <p>This report shows all the leave requests made by employees within a particular period along with description and status.</p>
                                <b-button @click="ShowLeaveRequestReportModal" > View Report</b-button>
                            </div>
                        </div>
                        <div v-if="flexible == 0" class="col-md-4 pr-0">
                            <!-- <div class="stats-info flex-fill">
                                <h6 class="text-left">Monthly Attendance Report</h6>
                                <hr>
                                <p class="text-left">
                                    <span class="font-weight-normal">
                                        This report shows attendance track for employees of each working day for a particular month.
                                    </span>
                                </p>
                                <div class="mt-2">
                                    <div class="d-flex justify-content-start">
                                        <b-button @click="ShowMonthlyAttendanceReportModal"> View Report</b-button>
                                    </div>
                                </div>
                            </div> -->
                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
                                <h5>Monthly Attendance Report</h5>
                                <p>This report shows attendance track for employees of each working day for a particular month.</p>
                                <b-button @click="ShowMonthlyAttendanceReportModal"> View Report</b-button>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div v-if="flexible == 0" class="col-md-4 pl-0">
                            <!-- <div class="stats-info flex-fill">
                                <h6 class="text-left">Attendance Summary</h6>
                                <hr>
                                <p class="text-left">
                                    <span class="font-weight-normal">
                                        This report shows summary of attendance for employees for a particular period along with % of present or absent.
                                    </span>
                                </p>
                                <div class="mt-1">
                                    <div class="d-flex justify-content-start">
                                        <b-button @click="ShowAttendanceSummaryReportModal"> View Report</b-button>
                                    </div>
                                </div>
                            </div> -->
                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
                                <h5>Attendance Summary</h5>
                                <p>This report shows summary of attendance for employees for a particular period along with % of present or absent.</p>
                                <b-button @click="ShowAttendanceSummaryReportModal"> View Report</b-button>
                            </div>
                        </div>

                        <div class="col-md-4 pl-0">
                            <!-- <div class="stats-info flex-fill">
                                <h6 class="text-left">Long Service Leave Summary</h6>
                                <hr>
                                <p class="text-left">
                                    <span class="font-weight-normal">
                                        This report shows summary of long service leave for all employees.
                                    </span>
                                </p>
                                <div class="mt-1">
                                    <div class="d-flex justify-content-start">
                                        <b-button @click="showLongServiceLeaveReportModal"> View Report</b-button>
                                    </div>
                                </div>
                            </div> -->
                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img :src="$api_url+'/images/Monthly_Payroll_Report.png'">
                                <h5>Long Service Leave Summary</h5>
                                <p>This report shows summary of long service leave for all employees.</p>
                                <b-button @click="showLongServiceLeaveReportModal"> View Report</b-button>
                            </div>
                        </div>

                        <l-a-reports v-if="flexible == 1"></l-a-reports>
                    </div>

                </div>

            </div>



        </div>
        <!-- end or reporting representation -->
        <!-- start of on click report  -->
        <b-modal id="bv-modal-leave-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Leave Report">
            <leave-report > </leave-report>
        </b-modal>
        <b-modal id="bv-modal-leave-request-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Leave Request Report">
            <leave-request-report > </leave-request-report>
        </b-modal>
        <b-modal id="bv-modal-monthly-attendance-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Monthtly Attendance Report">
            <monthly-attendance-report > </monthly-attendance-report>
        </b-modal>
        <b-modal id="bv-modal-attendance-summary-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Attendance Summary Report">
                <attendance-summary-report > </attendance-summary-report>
        </b-modal>
        <b-modal id="bv-modal-long-service-leave-report" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Long Service Leave Report">
                <l-a-long-service-leave-report > </l-a-long-service-leave-report>
        </b-modal>
    </div>
</template>
<script>



    export default{

        mounted() {

        },
       props: [],
        components: {

        },
        data(){

            return {
                flexible: 0, // asfaq 15 july 2025
            }
        },
        methods:{
            ShowLeaveReportModal: function (){
                this.$bvModal.show('bv-modal-leave-report');;
            },
            ShowLeaveRequestReportModal: function (){
                this.$bvModal.show('bv-modal-leave-request-report');;
            },
            ShowMonthlyAttendanceReportModal: function (){
                this.$bvModal.show('bv-modal-monthly-attendance-report');;
            },
            ShowAttendanceSummaryReportModal: function (){
                this.$bvModal.show('bv-modal-attendance-summary-report');;
            },
            // asfaq 15 july 2025
            getFlexibleSetting(){
                axios.get(this.$api_url + '/attendance-mobility/flexibility/status').then(response => {
                    this.flexible = response.data;
                })
            },
            // asfaq 15 july 2025
            // Ifti - 17-07-2025
            showLongServiceLeaveReportModal: function(){
                this.$bvModal.show('bv-modal-long-service-leave-report');
            }
            // Ifti - 17-07-2025

        },
        created: function(){

            this.getFlexibleSetting(); // asfaq 15 july 2025

        },
        computed:
        {

        }
    }
</script>
<style scoped>
.modal-lg, .modal-xl {
    max-width: 2000px !important;
}
</style>
